import { cartAmountsReducer } from "~/features/addToCart/redux/cartAmounts/reducer";
import { srpReducer } from "~/features/search/redux/reducer";
import { cartPageReducer } from "~/features/cart/cart/redux/reducers/cartPageReducer";
import { checkoutPageReducer } from "~/features/cart/cart/redux/reducers/checkoutPageReducer";
import { cartReducer } from "~/features/cart/cart/redux/reducers/cartReducer";
import { globalMessagesReducer } from "~/features/toasts/redux/reducer";
import { productsReducer } from "~/domains/product/redux/reducer";
import { contractsReducer } from "~/features/contracts/redux/reducer";
import { wishlistReducer } from "~/features/wishlist/redux/wishlistReducer";
import { productDetailsPageReducer } from "~/features/productDetails/redux/productDetailsReducer";
import { navigationReducer } from "~/features/navigation/redux/reducer";
import { linearConfiguratorReducer } from "~/features/configurator/Linear/redux/reducer";
import { externalContentReducer } from "~/features/externalContent/redux/reducer";

import { productComparisonReducer } from "~/features/compareProducts/redux/reducer";
import { regionSelectionBannerReducer } from "~/features/regionSelection/redux/reducer";
import { HOUSING_SA_REDUCER } from "~/features/selectionAssistant/housing/redux/reducer";
import { notificationsReducer } from "~/features/notifications/redux/NotificationsReducer";
import { saReducer } from "~/features/selectionAssistant/bearing/redux/reducer";
import { minicartReducer } from "~/features/cart/minicart/minicartRedux";
import { affiliateReducer } from "~/domains/affiliate/redux/reducer";
import { searchQueryReducer } from "~/features/search/redux/autosuggest/reducer";
import { navigationBreadcrumbsReducer } from "~/features/breadcrumbs/redux/reducer";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userPreferencesReducer from "~/domains/userPreferences/redux/userPreferencesSlice";

const rootReducer = combineReducers({
  cartPage: cartPageReducer,
  checkoutPage: checkoutPageReducer,
  cart: cartReducer,
  globalMessages: globalMessagesReducer,
  products: productsReducer,
  cartAmounts: cartAmountsReducer,
  linearConfigurator: linearConfiguratorReducer,
  regionSelectionBanner: regionSelectionBannerReducer,
  navigationBreadcrumbs: navigationBreadcrumbsReducer,

  contracts: contractsReducer,
  wishlistPage: wishlistReducer,

  srp: srpReducer,
  pdp: productDetailsPageReducer,
  sa: saReducer,
  navigation: navigationReducer,

  externalContent: externalContentReducer,
  productComparison: productComparisonReducer,
  housingSA: HOUSING_SA_REDUCER,
  userPreferences: userPreferencesReducer,

  notifications: notificationsReducer,

  minicart: minicartReducer,

  affiliate: affiliateReducer,

  search: searchQueryReducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    // @ts-expect-error
    preloadedState,
  });
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
